import ImageUpload from '@/js/_components/imageUpload';
import FileUpload from '@/js/_components/FileUpload';

const main = () => {
    const targetSelector = '.c-forms-input-image';
    const targetObjs = document.querySelectorAll(targetSelector);
    targetObjs.forEach(targetObj => {
        const uploadDir = targetObj.dataset.dir;
        const fileSizeLimit = targetObj.dataset.maxSize;
        const defaultImagePath = targetObj.querySelector('.preview').dataset.defaultPath;
        const typeFilter = targetObj.querySelector('input[type="file"]').accept
            .split(';')
        .map(item => item.trim())
        .filter(item => {
            return item.match(/image\/.*?/);
        });
        const imageUpload = new ImageUpload({
            targetObj,
            targetSelector,
            uploadDir,
            fileSizeLimit,
            defaultImagePath,
            typeFilter,
        });
    });
}

export default main;
